import { ParseError, parsePhoneNumber } from 'libphonenumber-js/max';
import { bool } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
const PHONE_NUMBER = 'phone-number';
function PhoneNumberValidator(value, { strictValidation = true } = {}) {
    if (!value) {
        return [];
    }
    try {
        const phone = parsePhoneNumber(value);
        const valid = strictValidation
            ? phone.isValid()
            : phone.isPossible();
        if (!valid) {
            return [{
                    message: ErrorMessage.DEFAULT,
                    name: PHONE_NUMBER,
                    valid: false,
                }];
        }
    }
    catch (e) {
        const message = e instanceof ParseError && e.message in ErrorMessage
            ? ErrorMessage[e.message]
            : ErrorMessage.DEFAULT;
        return [{
                message,
                name: PHONE_NUMBER,
                valid: false,
            }];
    }
    return [];
}
PhoneNumberValidator.optionTypes = {
    strictValidation: bool,
};
PhoneNumberValidator.defaultOptions = {
    strictValidation: true,
};
export { PHONE_NUMBER, PhoneNumberValidator, };
export default PhoneNumberValidator;
var ErrorMessage;
(function (ErrorMessage) {
    ErrorMessage["DEFAULT"] = "tws.validator.phone-number-invalid";
    /**
     * When defaultCountry doesn't exist (parsePhoneNumber('(111) 222-3333', 'XX')) or isn't supported by this library,
     * or when parsing non-international number without a defaultCountry (parsePhoneNumber('(111) 222-3333')),
     * or when international number country calling code doesn't exist (parsePhoneNumber('+9991112223333')).
     */
    ErrorMessage["INVALID_COUNTRY"] = "tws.validator.phone-number-invalid-country";
    /**
     * When no phone number was found.
     * For example, when there are no digits ("abcde")
     * or when there's not enough digits (parsePhoneNumber('2', 'US'), parsePhoneNumber('+1')).
     */
    ErrorMessage["NOT_A_NUMBER"] = "tws.validator.phone-number-invalid";
    /**
     * When national (significant) number is too long (17 digits max)
     * or when the string being parsed is too long (250 characters max).
     */
    ErrorMessage["TOO_LONG"] = "tws.validator.phone-number-too-long";
    /**
     * When national (significant) number is too short (for ex. 1 digit).
     */
    ErrorMessage["TOO_SHORT"] = "tws.validator.phone-number-too-short";
})(ErrorMessage || (ErrorMessage = {}));
//# sourceMappingURL=phone-number.js.map